
import { Component, Prop, Vue } from 'vue-property-decorator'
import CountTo from 'vue-count-to'
import { IStatData } from '@/types/home-types'

@Component({
    name: 'TotalStat',
    components: {
        CountTo
    }
})
export default class extends Vue {
    @Prop({ required: true }) private stat!: IStatData
    private duration: number = 2600

    private onGoReporterList() {
        this.$router.push({ name: 'ReporterList' })
    }

    private onGoMediaList() {
        this.$router.push({ name: 'MediaList' })
    }

    private onGoNewsList() {
        this.$router.push({ name: 'NewsList' })
    }
}
